import React, { Component } from "react";
import { saveItCareerForm } from "../service.js";
import Close from "../images/close-mark.png";
import Edit from "../images/edit.png";
import Active from "../images/active.png";
import Inactive from "../images/inactive.png";
import $ from "jquery";
const Header = React.lazy(() => import("../layout/header"))
const Footer = React.lazy(() => import("../layout/admin_footer"))
class UserList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      getDataList: [],
      valueForMapingPopUp: [],
      disspossiblearray: [],
      passwordflag: true,
      getCheckbox: [],
      getCheckboxAdd: [],
      checkBoxid: [],
      secuserid: '',
      userPageId: [],
      secUserName: '',
      secUserIdForEdit: '',
      getDataListforcheckbox: [],
      getDataListforcheckbox2: [],
      checkboxidforedit: [],
      mobileNumber: "",
      emailId: "",
      isEditorOk: ""
    };
    this.handleInputChange = this.handleInputChange.bind(this);
  }
  componentDidMount() {
    if (localStorage.getItem("isLogedIn") === "null" || localStorage.getItem("isLogedIn") === null) {
        window.location.href = '/cms-login'
      }
    $("#popupModal").hide();
    $("#popupModalpass").hide();
    this.userlist();
    this.userlistedit()
    const postData = {
      functionName: "adminProjectPages",
    };
    saveItCareerForm(postData).then((data) => {
      this.setState({
        getCheckbox: data.data.result,
        getCheckboxAdd: data.data.result,

        getDataListforcheckbox2: data.data.result
      });
    });
  }
  userlist() {
    const postDataMessage = {
      functionName: "usersList",
    };
    saveItCareerForm(postDataMessage).then((data) => {
      this.setState({
        getDataList: data.data.result,
      });
    });
  }
  userlistedit() {
    const postDataMessage = {
      functionName: "usersList",
    };
    saveItCareerForm(postDataMessage).then((data,) => {
      data.data.result.map((item, i) => (
        item.userPageDetails.map((value) => (
          this.setState({
            getDataListforcheckbox: value.isUserPage
          })
        ))
      ))
    });
  }
  ChangeEnableDisable(secUserId, status) {
    var x = false;
    if (status === true) {
      x = window.confirm("Do you want to Enable this?");
    } else {
      x = window.confirm("Do you want to Disable this?");
    }
    if (x === true) {
      const postDataMessage = {
        functionName: "userStatusChange",
        userId: secUserId,
        status: status === false ? false : true,
      };
      saveItCareerForm(postDataMessage).then((data) => {
        if (data.data.success === "1") {
          alert("Status Changed successfully")
          this.userlist()
        }
      });
    }
  }
  PopupShowEdit(ClickedFunction, PopupValue) {
    if (ClickedFunction === "MainAdd") {
      if (this.state.getCheckbox !== "") {
        for (let index = 0; index < this.state.getCheckbox.length; index++) {
          this.state.getCheckboxAdd[index].isUserPage = false
        }
      }
      $("#emailIdSave").val("")
      $("#AddingNewName").val("")
      $("#mobileNumberSave").val("")
      $("#Password").val("")
      this.setState({
        disspossiblearray: [],
        valueForMapingPopUp: [],
        passwordflag: false,
        checkBoxid: '',
      });
      $(".adminpopup_wrapr").show();
    }
    this.setState({
      disspossiblearray: PopupValue.subLinks,
    });
    if (ClickedFunction === "Edit") {
      if (PopupValue.isEditor === "") {
        if (PopupValue.isEditor === true) {
          $("#Editor").attr('checked', true);
        }
      }
      this.setState({
        valueForMapingPopUp: [PopupValue],
        passwordflag: false,
        secUserName: PopupValue.secUserName,
        secUserIdForEdit: PopupValue.secUserId,
        getCheckbox:
          PopupValue.userPageDetails.length > 0 ?
            PopupValue.userPageDetails.map((value) => (
              value
            )) :
            this.state.getDataListforcheckbox2.map((flag) => (
              flag
            )),
        checkboxidforedit: PopupValue.userPageDetails.filter((obj) => obj.isUserPage === true).map((dataflag) => (
          dataflag.projectPagesId
        ))
      });
      $(".adminpopup_wrapr").show();
    } else if (ClickedFunction === "Cancel") {
      $(".adminpopup_wrapr").hide();
      $("#emailIdSave").val("")
      $("#AddingNewName").val("")
      $("#mobileNumberSave").val("")
      $("#Password").val("")
      this.setState({
        valueForMapingPopUp: [],
        disspossiblearray: [],
        passwordflag: false,
      });
    } else if (ClickedFunction === "Password") {
      this.setState({
        passwordflag: true,
        secuserid: PopupValue.secUserId
      });
      $(".adminpopup_wrapr").show();
    }
  }
  SaveHeaderLink() {
    var mobile = /^\d{10}$/;
    var characters = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    let Email = $("#emailIdSave").val()
    let mobilenumber = $("#mobileNumberSave").val()
    var flag = true;
    if ($("#AddingNewName").val() === "") {
      flag = false;
      alert("Name Required");
    }
    else if ($("#emailIdSave").val() === "") {
      flag = false;
      alert("EmailId Required");
    }
    else if (characters.test(Email) === false) {
      flag = false;
      alert("Enter Valid EmailId");
    }
    else if ($("#mobileNumberSave").val() === "") {
      flag = false;
      alert("Mobile Number Required");
    }
    else if (!(mobilenumber.match(mobile))) {
      flag = false;
      alert("Enter Valid Mobile Number");
    }
    else if ($("#Password").val() === "") {
      flag = false;
      alert("Password Required");
    } 
    else if ($("#drConfirmPassword").val() === "") {
      flag = false;
      alert("Confirm Password Required");
    }
    else if ($("#Password").val() !== $("#drConfirmPassword").val() ) {
      flag = false;
      alert("Password and Confirm Password does not match");
    }
    if (flag === true) {
      const postData = {
        "functionName": "createUser",
        "id": this.state.secUserIdForEdit,
        "password": this.state.Password,
        "name": this.state.AddingNewName,
        "phoneNumber": $("#mobileNumberSave").val(),
        "selectedUserPages": this.state.checkBoxid,
        "isEditor": this.state.isEditorOk,
        "userName": $("#emailIdSave").val(),
      };
      saveItCareerForm(postData).then((data) => {
        if (data.data.success === "1") {
          alert("User added successfully");
          $(".adminpopup_wrapr").hide();
          this.userlist();
        } else {
          return false;
        }
      });
    }
  }
  PasswordChange() {
    var dataflag = true
    if ($("#Password").val() === "") {
      dataflag = false;
      alert("please enter password");
    } else if ($("#drConfirmPassword").val() === "") {
      dataflag = false;
      alert("please enter confirm password");
    }
    else if ($('#Password').val() !== $('#drConfirmPassword').val()) {
      dataflag = false
      alert('password and confirm password does not match')
    }
    if (dataflag === true) {
      const postData = {
        functionName: "userChangePassword",
        userId: this.state.secuserid,
        newPassword: this.state.Password,
      };
      saveItCareerForm(postData).then((data) => {
        if (data.data.success === "1") {
          alert(data.data.successMessage);
          $(".adminpopup_wrapr").hide();
          window.location.reload()
          this.userlist();
        } else {
          return false;
        }
      });
    }
  }
  handleInputChange = (event) => {
    const { value, name } = event.target;
    this.setState({
      [name]: value,
    });
  };
  handleCheckbox = (testid, e, id) => {
    const { name, checked } = e.target;
    const values = [...this.state.getCheckboxAdd];
    values[id] = { ...values[id], [name]: checked };
    this.setState({ getCheckboxAdd: values });
    let newArray = [...this.state.checkBoxid, testid];
    if (this.state.checkBoxid.includes(testid)) {
      newArray = newArray.filter((checked) => checked !== testid);
    }
    this.setState({
      checkBoxid: newArray,
    });
  };
  handleCheckboxEdit = (testid, e, id) => {
    const { name, checked } = e.target;
    const values = [...this.state.getCheckbox];
    values[id] = { ...values[id], [name]: checked };
    this.setState({ getCheckbox: values });
    let newArray = [...this.state.checkboxidforedit, testid];
    if (this.state.checkboxidforedit.includes(testid)) {
      newArray = newArray.filter((checked) => checked !== testid);
    }
    this.setState({
      checkboxidforedit: newArray,
    });
  };
  handeUpdate() {
    var mobile = /^\d{10}$/;
    var characters = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    let Email = $("#secUserName").val()
    let mobilenumber = $("#mobileNUmber").val()
    var flag = true;
    if ($("#secName").val() === "") {
      flag = false;
      alert("Name Required");
    }
    // else if ($("#drConfirmPassword").val() == "") {
    //   flag = false;
    //   alert("please enter confirm password");
    // }
    else if ($("#secUserName").val() === "") {
      flag = false;
      alert("EmailId Required");
    }
    else if (!(Email.match(characters))) {
      flag = false;
      alert("Enter Valid EmailId");
    } 
    else if (this.state.valueForMapingPopUp[0].mobileNUmber === "") {
      flag = false;
      alert("Mobile Number Required");
    }
    else if (!(mobilenumber.match(mobile))) {
      flag = false;
      alert("Enter Valid Mobile Number");
    }
    else if (flag === true) {
      const postData = {
        "functionName": "createUser",
        "id": this.state.valueForMapingPopUp[0].secUserId,
        "password": this.state.Password,
        "name": $("#secName").val(),
        "phoneNumber": $("#mobileNUmber").val(),
        "selectedUserPages": this.state.checkboxidforedit,
        "isEditor": this.state.isEditorOk,
        "userName": $("#secUserName").val(),
      }
      saveItCareerForm(postData).then((data) => {
        if (data.data.success === "1") {
          alert("User Updated successfully");
          $(".adminpopup_wrapr").hide();
          window.location.reload()
          this.userlist();
        } else {
          return false;
        }
      });
    }
  }
  categoryTypeNewChange = (e, i) => {
    const { name, value } = e.target;
    const values = [...this.state.valueForMapingPopUp];
    values[i] = { ...values[i], [name]: value };
    this.setState({ valueForMapingPopUp: values });
  };
  primarySpecial = (id, value) => {
    if (value === true) {
    }
    if (
      document.getElementById('Editor').checked === true) {
      this.setState({
        isEditorOk: "1",
      });
      document.getElementById('Viewer').checked = false
    }
    if (document.getElementById('Editor').checked === false) {
      document.getElementById('Viewer').checked = true
      this.setState({
        isEditorOk: "0",
      });
    }
  };
  render() {
    return (
      <div className="admin_dashboard_wrapr" style={{ position: "relative" }}>
        <Header />
        <div className="container">
          <div className="breadcrumbs">
            <ul>
              <li>
                <a href="/dashboard" class="breadcrumbLink">
                  Dashboard
                </a>
              </li>
              <div class="breadcrumbarrow-right" />
              <li> Users List</li>
            </ul>
          </div>
          <div className="admin_mainwrapper">
            <div className="admin_addbtn_div">
              <button
                className="admin_addbtn"
                onClick={() => this.PopupShowEdit("MainAdd", "")}
              >
                Add
              </button>
            </div>
            <div className="table-responsive admin_table">
              <table>
                <tr>
                  <th>Serial No</th>
                  <th>Name</th>
                  <th>Report Access</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
                {this.state.getDataList.map((item, k) => (
                  <>
                    <tr>
                      <td>{k + 1}</td>
                      <td>
                        <b>{item.secName}</b>
                        <p>{item.secUserName}</p>
                        <p>{item.mobileNUmber}</p>
                        </td>
                      <td className="p-1">
                        <table className="submenu_table">
                          {item.userPageDetails.filter((obj) => obj.isUserPage === true).map((data) => (
                            <>
                              <li>{data.projectPagesName}</li>
                            </>
                          ))}
                        </table>
                      </td>
                      <td className="no-wrap">
                        {item.isEnabled === 1 ? (
                          <span className="status_iconImg">
                            <img
                              src={Active}
                              onClick={() =>
                                this.ChangeEnableDisable(item.secUserId, false)
                              }
                              alt="Active"
                              width={20}
                              title ="Click to Disable"
                              className="cursorpointer"
                            />
                          </span>
                        ) : (
                          <span className="status_iconImg">
                            <img
                            title ="Click to Enable"
                              src={Inactive}
                              onClick={() =>
                                this.ChangeEnableDisable(item.secUserId, true)
                              }
                              alt="Inactive"
                              width={20}
                              className="cursorpointer"
                            />
                          </span>
                        )}
                      </td>
                      <td>
                        <img
                          src={Edit}
                          onClick={() => this.PopupShowEdit("Edit", item)}
                          alt="Edit"
                          width={20}
                          className="cursorpointer"
                        />
                        <div
                          onClick={() => this.PopupShowEdit("Password", item)}
                          className="chnge_passwrdtext"
                        >
                          Password Change
                        </div>
                      </td>
                    </tr>
                  </>
                ))}
              </table>
            </div>
          </div>
        </div>
        <Footer />
        <div class="adminpopup_wrapr" id="popupModal">
          {this.state.valueForMapingPopUp.length > 0 ? (
            <>
              {this.state.valueForMapingPopUp.map((itemSubMenuPpoUp, k) => (
                <div class="reveal-modal">
                  <div
                    className="popup_close"
                    onClick={() => this.PopupShowEdit("Cancel", "")}
                  >
                    <img
                      src={Close}
                      alt="Close"
                      width={25}
                      className="close_btn"
                    />
                  </div>
                  <div class="form-group row">
                    <label class="col-sm-3 col-form-label">Name</label>
                    <div class="col-sm-9">
                      <input
                        type="text"
                        value={itemSubMenuPpoUp.secName}
                        class="form-control"
                        placeholder="Name"
                        onChange={(e) => { this.categoryTypeNewChange(e, k) }}
                        id="secName"
                        name="secName"
                      />
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-sm-3 col-form-label">Email Id</label>
                    <div class="col-sm-9">
                      <input
                        type="text"
                        defaultValue={itemSubMenuPpoUp.secUserName}
                        class="form-control"
                        placeholder="Email Id"
                        onChange={(e) => { this.categoryTypeNewChange(e, k) }}
                        id="secUserName"
                        name="secUserName"
                      />
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-sm-3 col-form-label">Mobile Number</label>
                    <div class="col-sm-9">
                      <input
                        type="text"
                        defaultValue={itemSubMenuPpoUp.mobileNUmber}
                        class="form-control"
                        placeholder="Mobile Number"
                        maxlength="10"
                        // onChange={this.handleInputChange}
                        onChange={(e) => { this.categoryTypeNewChange(e, k) }}
                        id="mobileNUmber"
                        name="mobileNUmber"
                      />
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-sm-3 col-form-label">User Type</label>
                    <div class="col-sm-9">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="radioInputLabel">Editor</div>
                          <input type="radio" value={true} defaultChecked={itemSubMenuPpoUp.isEditor === true ? true : false} id="Editor" onChange={(e) =>
                            this.primarySpecial(
                              e.target.checked
                            )} name="optradio"></input>
                        </div>
                        <div className="col-md-6">
                          <div className="radioInputLabel">Viewer</div>
                          <input type="radio" value={false} defaultChecked={itemSubMenuPpoUp.isEditor === false ? true : false} id="Viewer" onChange={(e) =>
                            this.primarySpecial(
                              e.target.checked
                            )} name="optradio" ></input>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-sm-3 col-form-label"  >Page Access</label>
                    <div className="col-md-9">
                      <div className="row">
                        {this.state.getCheckbox.map((datavalue, i) => (
                          <div className="col-md-6">
                            <input
                              type="checkbox"
                              checked={datavalue.isUserPage}
                              id={"moduleSubLeftSubAdd160113" + datavalue.projectPagesId}
                              name="isUserPage"
                              onClick={(e) =>
                                this.handleCheckboxEdit(datavalue.projectPagesId, e, i)
                              }
                            />
                            <label
                              for={"moduleSubLeftSubAdd160113" + datavalue.projectPagesId}
                            />
                            <span class="reportLabelTxt">{datavalue.projectPagesName || datavalue.ProjectPagesName}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="submit_buttons">
                    <button
                      className="save_btn"
                      onClick={() => this.handeUpdate()}
                    >
                      Save
                    </button>
                    <button
                      className="save_btn cancel_btn"
                      onClick={() => this.PopupShowEdit("Cancel", "")}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              ))}
            </>
          ) : (
            ////////////////////////////////////////////////////////////////////////////////////
            <>
              <div class="reveal-modal">
                <div
                  className="popup_close"
                  onClick={() => this.PopupShowEdit("Cancel", "")}
                >
                  <img
                    src={Close}
                    alt="Close"
                    width={25}
                    className="close_btn"
                  />
                </div>
                {this.state.passwordflag === false && (
                  <>
                    <div class="form-group row">
                      <label class="col-sm-3 col-form-label pr-0">Name</label>
                      <div class="col-sm-9">
                        <input
                          onChange={this.handleInputChange}
                          type="text"
                          id="AddingNewName"
                          name="AddingNewName"
                          class="form-control"
                          placeholder="Name"
                        />
                      </div>
                    </div>
                  </>
                )}
                {this.state.passwordflag === false && (
                  <>
                    <div class="form-group row">
                      <label class="col-sm-3 col-form-label pr-0">Email Id</label>
                      <div class="col-sm-9">
                        <input
                          onChange={this.handleInputChange}
                          type="text"
                          name="emailIdSave"
                          id="emailIdSave"
                          class="form-control"
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label class="col-sm-3 col-form-label pr-0">Mobile Number</label>
                      <div class="col-sm-9">
                        <input
                          onChange={this.handleInputChange}
                          type="text"
                          name="mobileNumberSave"
                          id="mobileNumberSave"
                          maxlength="10"
                          class="form-control"
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label class="col-sm-3 col-form-label">User Type</label>
                      <div class="col-sm-9">
                        <div className="row">
                          <div className="col-md-6">
                            <div className="radioInputLabel">Editor</div>
                            <input type="radio" id="Editor" onChange={(e) =>
                              this.primarySpecial(
                                e.target.checked
                              )} name="optradio"></input>
                          </div>
                          <div className="col-md-6">
                            <div className="radioInputLabel">Viewer</div>
                            <input type="radio" id="Viewer" onChange={(e) =>
                              this.primarySpecial(
                                e.target.checked
                              )} name="optradio" ></input>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
                {this.state.passwordflag === false && (
                  <>
                    <div class="form-group row">
                      <label class="col-sm-3 col-form-label pr-0">
                        Page Access
                      </label>
                      <div class="col-sm-9">
                        <div className="row">
                          {this.state.getCheckboxAdd.map((value, i) => (
                            <div className="col-md-6">
                              <input
                                type="checkbox"
                                checked={value.isUserPage}
                                id={
                                  "moduleSubLeftSubAdd1601131" + value.projectPagesId
                                }
                                name="isUserPage"
                                onChange={(e) =>
                                  this.handleCheckbox(value.projectPagesId, e, i)
                                }
                              />
                              <label
                                for={
                                  "moduleSubLeftSubAdd1601131" + value.projectPagesId
                                }
                              />
                              <span class="reportLabelTxt">
                                {value.ProjectPagesName || value.projectPagesName}
                              </span>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </>
                )}
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label pr-0">Password</label>
                  <div class="col-sm-9">
                    <input
                      onChange={this.handleInputChange}
                      type="password"
                      name="Password"
                      id="Password"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label pr-0">
                    Confirm Password
                  </label>
                  <div class="col-sm-9">
                    <input
                      type="password"
                      name="drConfirmPassword"
                      id="drConfirmPassword"
                      onChange={this.handleInputChange}
                      class="form-control"
                    />
                  </div>
                </div>
                {/* : []}  */}
                {this.state.passwordflag === false ? (
                  <div className="submit_buttons">
                    <button
                      className="save_btn"
                      onClick={() => this.SaveHeaderLink()}
                    >
                      Save
                    </button>
                    <button
                      className="save_btn cancel_btn"
                      onClick={() => this.PopupShowEdit("Cancel", "")}
                    >
                      Cancel
                    </button>
                  </div>
                ) : (
                  <div className="submit_buttons">
                    <button
                      className="save_btn"
                      onClick={() => this.PasswordChange()}
                    >
                      Save
                    </button>
                    <button
                      className="save_btn cancel_btn"
                      onClick={() => this.PopupShowEdit("Cancel", "")}
                    >
                      Cancel
                    </button>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
        <div class="adminpopup_pass" id="popupModalpass">
          <>
            <div class="reveal-modal">
              <div
                className="popup_close"
                onClick={() => this.PopupShowEdit("Cancel", "")}
              >
                <img src={Close} alt="Close" width={25} className="close_btn" />
              </div>
              <div class="form-group row">
                <label class="col-sm-2 col-form-label">Password</label>
                <div class="col-sm-10">
                  <input
                    type="text"
                    id="AddingNewSortOut"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-2 col-form-label">Confirm Password</label>
                <div class="col-sm-10">
                  <input
                    type="text"
                    id="AddingNewSortOut"
                    class="form-control"
                  />
                </div>
              </div>
              {/* : []}  */}
              <div className="submit_buttons">
                <button
                  className="save_btn"
                  onClick={() => this.SaveHeaderLink(false, "MainStattus")}
                >
                  Save
                </button>
                <button
                  className="save_btn cancel_btn"
                  onClick={() => this.PopupShowEdit("Cancel", "")}
                >
                  Cancel
                </button>
              </div>
            </div>
          </>
        </div>
      </div>
    );
  }
}
export default UserList;
